import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AppendixStructuresResponse } from "../Models/appendixStructure";
import {
  deletePredefinedSections,
  fetchPredefinedSections,
  putPredefinedSections,
} from "../Api/predefinedSections";

export const usePredefinedSections = (
  workspaceId?: number,
  enabled: boolean = true,
) => {
  return useQuery<AppendixStructuresResponse, Error>({
    queryKey: ["predefinedSections", workspaceId],
    queryFn: () => fetchPredefinedSections(workspaceId),
    enabled,
  });
};

export const usePutPredefinedSections = (workspaceId?: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putPredefinedSections,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["predefinedSections", workspaceId] });
    },
  });
};

export const useDeletePredefinedSections = (workspaceId?: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deletePredefinedSections(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["predefinedSections", workspaceId] });
    },
  });
};
